<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
import "@/controllers";
export default {
  name: "Controller",
  mounted() {
    const klass = eval(this.$el.dataset.controller);
    if (klass) {
      const delay = this.$el.dataset.delay || 0;
      setTimeout(() => {
        new klass(this.$el).init();
      }, delay);
    }
  },
};
</script>
